import {
	defineStore
} from "pinia";
import { handleErrorToast } from '../lib/fetchHandlers'

export const useTrackAudioFeatureStore = defineStore('trackAudioFeature', {
	state: () => ({
		trackAudioFeatures: {},
	}),
	getters: {
		get: (state) => {
			return (id) => state.trackAudioFeatures[id] || null;
		},
	},
	actions: {
		add (id, results) {
			this.trackAudioFeatures[id] = results;
		},
		async fetch (id) {
			if (this.trackAudioFeatures[id]) {
				return this.trackAudioFeatures[id];
			}
			return window.spotifyApi.getAudioFeaturesForTrack(id)
				.then((data) => {
					console.log('features', data.body);
					this.add(id, data.body);
					return data.body;
				}, (err) => {
					handleErrorToast(err, 'Fetch audio features error');
					return null;
				});
		},
	},
});
